export default "__VITE_ASSET__CF8yvM2h__"